
import { Shimmer } from "@/components/ui/shimmer";

const MealsLoadingState = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {[1, 2, 3].map((i) => (
        <div key={i} className="rounded-lg overflow-hidden border border-border">
          <Shimmer className="h-48" /> {/* Image placeholder */}
          <div className="p-4 space-y-4">
            <Shimmer className="h-6 w-3/4" /> {/* Title placeholder */}
            <Shimmer className="h-4 w-1/4" /> {/* Price placeholder */}
            <div className="space-y-2">
              <Shimmer className="h-4 w-full" /> {/* Description line 1 */}
              <Shimmer className="h-4 w-2/3" /> {/* Description line 2 */}
            </div>
            <div className="flex gap-2">
              <Shimmer className="h-4 w-20" /> {/* Tag placeholder */}
              <Shimmer className="h-4 w-20" /> {/* Tag placeholder */}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MealsLoadingState;
